export const environment = {
  production: false,
  API: 'https://novo-clinica-api-f0c1c2456b64.herokuapp.com/',
  iugu_pg_id: '0CB677CD5D024435B139911CE98CDC20',
};
